import { env } from '../../config/env';
import type { AdminPreOrder, PreOrder, PreOrderInput, PreOrderStatus } from '../../types';
import * as http from './preOrdersService.http';
import * as mock from './preOrdersService.mock';

export interface PreOrdersService {
  fetchPreOrders(): Promise<PreOrder[]>;
  createPreOrder(input: PreOrderInput): Promise<PreOrder>;
  fetchAdminPreOrders(status?: PreOrderStatus): Promise<AdminPreOrder[]>;
  updateAdminPreOrder(
    id: string,
    status: 'fulfilled' | 'cancelled',
    adminNote?: string | null,
  ): Promise<AdminPreOrder>;
}

const mockPreOrdersService: PreOrdersService = {
  fetchPreOrders: mock.mockFetchPreOrders,
  createPreOrder: mock.mockCreatePreOrder,
  fetchAdminPreOrders: mock.mockFetchAdminPreOrders,
  updateAdminPreOrder: mock.mockUpdateAdminPreOrder,
};

const httpPreOrdersService: PreOrdersService = {
  fetchPreOrders: http.httpFetchPreOrders,
  createPreOrder: http.httpCreatePreOrder,
  fetchAdminPreOrders: http.httpFetchAdminPreOrders,
  updateAdminPreOrder: http.httpUpdateAdminPreOrder,
};

export const preOrdersService: PreOrdersService = env.useMock
  ? mockPreOrdersService
  : httpPreOrdersService;
